import {usePromotionStore} from './useStore'

export const usePromotion = (productPromotionId?: string) => {
  const {promotions} = usePromotionStore()

  return productPromotionId ? promotions[productPromotionId] : null
}
